module.exports = __webpack_public_path__ + "static/media/zoom_road.31be2af8.jpg";